export default "__VITE_ASSET__C6KW9deL__"